import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Eye, EyeOff, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CommercialLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Email et mot de passe requis'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/commercial/login`, { email, password });
      localStorage.setItem('commercial_token', res.data.access_token);
      localStorage.setItem('commercial_data', JSON.stringify(res.data.commercial));
      navigate('/commercial/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/10 mb-4">
            <Building2 className="w-8 h-8 text-amber-400" />
          </div>
          <h1 className="text-3xl font-bold text-white">Espace Commercial</h1>
          <p className="text-slate-400 mt-2">L'Œil du Marchand</p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <Label className="text-slate-300 text-sm font-medium">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="votre@email.com"
                className="mt-1.5 bg-white/10 border-white/20 text-white placeholder:text-slate-500 focus:border-amber-400"
                data-testid="commercial-login-email"
                autoComplete="email"
              />
            </div>
            <div>
              <Label className="text-slate-300 text-sm font-medium">Mot de passe</Label>
              <div className="relative mt-1.5">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-white/10 border-white/20 text-white placeholder:text-slate-500 focus:border-amber-400 pr-10"
                  data-testid="commercial-login-password"
                  autoComplete="current-password"
                />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition-colors">
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-amber-500 hover:bg-amber-600 text-black font-semibold py-2.5 mt-2"
              data-testid="commercial-login-submit"
            >
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Connexion...</> : 'Se connecter'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
